import { takeLatest, takeEvery } from 'redux-saga/effects';

import {
  GET_DOSSIERS,
  CREATE_DOSSIER,
  DELETE_DOSSIER,
  GET_DOSSIER,
  GET_DOSSIER_ITEMS,
  TOGGLE_DOSSIER_WATCHED_STATE,
} from './dossierActions';
import {
  fetchDossiersSaga,
  createDossierSaga,
  deleteDossiersSaga,
  fetchDossierSaga,
  fetchDossierItemsSaga,
  toggleDossierWatchedStateSaga,
} from './dossierSaga';

export function* dossierWatchers() {
  yield takeLatest(GET_DOSSIER, fetchDossierSaga);
  yield takeEvery(GET_DOSSIER_ITEMS, fetchDossierItemsSaga);
  yield takeEvery(GET_DOSSIERS, fetchDossiersSaga);
  yield takeLatest(CREATE_DOSSIER, createDossierSaga);
  yield takeLatest(DELETE_DOSSIER, deleteDossiersSaga);
  yield takeLatest(TOGGLE_DOSSIER_WATCHED_STATE, toggleDossierWatchedStateSaga);
}
